/*
 * File: axios.tsx
 * Project: a-a
 * File Created: Tuesday, 15th October 2024 7:49:39 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 25th October 2024 2:07:34 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_URI,
  headers: { 'Content-Type': 'application/json' },
});

export default instance;
